import React from "react";
import {
  Box,
  Grid,
  GridItem,
  VStack,
} from "@chakra-ui/react";
import { DashboardResponse } from "../types";

interface Props {
  data: DashboardResponse[];
}

function transformResponse(data: DashboardResponse[]) {
  const rowMap = new Map<string, { location: string; consumedEnergy: number; producedEnergy: number; temperature: number }>();

  data.forEach((record) => {
    record.values.forEach((value) => {
      const location = value.label;
      const existing = rowMap.get(location) || {
        location,
        consumedEnergy: 0,
        producedEnergy: 0,
        temperature: 0,
      };

      if (record.parameter_title === "totalconsumedenergy") {
        existing.consumedEnergy += value.value;
      } else if (record.parameter_title === "totalgeneratedenergy") {
        existing.producedEnergy += value.value;
      } else if (record.parameter_title === "temperature") {
        existing.temperature += value.value;
      }

      rowMap.set(location, existing);
    });
  });

  return Array.from(rowMap.values());

}

export function ListView({ data }: Props) {
  const rows = transformResponse(data)

  const totalConsumed = rows.reduce((acc, r) => acc + r.consumedEnergy, 0);
  const totalProduced = rows.reduce((acc, r) => acc + (r.producedEnergy || 0), 0);

  return (
    <Box p={4} w="100%" borderRadius="md" bg="white">
      <Grid
        templateColumns="2fr 1.5fr 1.5fr 1.5fr"
        gap={4}
        fontWeight="600"
        fontSize="sm"
        color="#9B9B9B"
        borderBottom="1px solid #E2E8F0"
        pb={2}
        mb={2}
      >
        <GridItem>Location</GridItem>
        <GridItem>Consumed energy</GridItem>
        <GridItem>Produced energy</GridItem>
        <GridItem>Temperature</GridItem>
      </Grid>

      <VStack spacing={3} align="stretch">
        {rows.map((row, i) => (
          <Grid
            key={i}
            templateColumns="2fr 1.5fr 1.5fr 1.5fr"
            gap={4}
            fontWeight="500"
            fontSize="sm"
            alignItems="center"
            color="#484848"
          >
            <GridItem>{row.location}</GridItem>
            <GridItem fontWeight={400}>{row.consumedEnergy ? `${row.consumedEnergy.toFixed(2)} kWh` : "-"}</GridItem>
            <GridItem>{row.producedEnergy ? `${row.producedEnergy.toFixed(2)} kWh` : "-"}</GridItem>
            <GridItem>{row.temperature ? `${row.temperature.toFixed(2)} °C` : "-"}</GridItem>
          </Grid>
        ))}
      </VStack>

      <Grid
        templateColumns="2fr  1.5fr 1.5fr 1.5fr"
        gap={4}
        fontWeight="700"
        fontSize="sm"
        color="#484848"
        mt={4}
        pt={4}
        borderTop="2px solid #E2E8F0"
      >
        <GridItem fontWeight={400} color="#9B9B9B">Total:</GridItem>
        <GridItem fontWeight={700}>{totalConsumed.toFixed(2)} <span style={{ fontWeight: 400, color: "#707070" }}>kWh</span></GridItem>
        <GridItem fontWeight={700}>{totalProduced.toFixed(2)} <span style={{ fontWeight: 400, color: "#707070" }}>kWh</span></GridItem>
      </Grid>
    </Box>
  );
}
